import { render, staticRenderFns } from "./newsRecordList.vue?vue&type=template&id=26ebb7ca&scoped=true"
import script from "./newsRecordList.vue?vue&type=script&lang=js"
export * from "./newsRecordList.vue?vue&type=script&lang=js"
import style0 from "./newsRecordList.vue?vue&type=style&index=0&id=26ebb7ca&prod&lang=less&scoped=scoped"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26ebb7ca",
  null
  
)

export default component.exports